'use client'

import { useEffect } from 'react'

/** Contact + footer share the last snap screen: publish the footer's height to CSS (--home-footer-h). */
export default function FooterHeightVar() {
  useEffect(() => {
    const footer = document.querySelector('footer')
    if (!footer) return
    const root = document.documentElement
    let last = -1
    const observer = new ResizeObserver(() => {
      const h = footer.offsetHeight
      if (h === last) return
      last = h
      root.style.setProperty('--home-footer-h', `${h}px`)
      // page height changed: let the globe re-measure where each section sits
      window.dispatchEvent(new Event('resize'))
    })
    observer.observe(footer)
    return () => {
      observer.disconnect()
      root.style.removeProperty('--home-footer-h')
    }
  }, [])
  return null
}
